import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonItem,
  IonLabel,
  IonProgressBar,
  IonNote,
} from "@ionic/react";
import Peep from "react-peeps";
import "./Tab2.css";

const styles = {
  peepStyle: {
    width: 300,
    height: 300,
    justifyContent: "center",
    alignSelf: "center",
  },
  showcaseWrapper: {
    display: "flex",
    justifyContent: "center",
  },
};

const Tab2: React.FC<{
  exp: number;
  gold: number;
  peepConfig: {};
}> = ({ exp, gold, peepConfig }) => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>kev-inc</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div style={styles.showcaseWrapper}>
          <Peep
            style={styles.peepStyle}
            accessory={peepConfig["accessory"]}
            body={peepConfig["body"]}
            face={peepConfig["face"]}
            hair={peepConfig["hair"]}
            facialHair={peepConfig["facialHair"]}
          />
        </div>
        <IonItem lines="none">
          <IonLabel class="ion-text-center">
            Level {Math.floor(exp / 100)}
          </IonLabel>
        </IonItem>
        <IonItem lines="none">
          <IonProgressBar value={(exp % 100) / 100}></IonProgressBar>
        </IonItem>
        <IonItem lines="none">
          <IonLabel class="ion-text-center">{gold} gold</IonLabel>
        </IonItem>
      </IonContent>
    </IonPage>
  );
};

export default Tab2;
